import { graphql } from "~/gql";

export const UPDATE_QUICK_UPDATE_SHOWN_AT = graphql(/* GraphQL */ `
  mutation updateQuickUpdateShownAt {
    updateQuickUpdateShownAt {
      id
    }
  }
`);
